import tns from '@/lib/tiny-slider/tiny-slider.js';

document.addEventListener('DOMContentLoaded', function () {
    // Initialize tiny-slider for each carousel element
    var carousels = document.querySelectorAll('.notices-modal-items .notices-modal-carousel');
    carousels.forEach(function (carousel) {
        var parent = carousel.closest('.notices-modal-items');
        var prevBtn = parent ? parent.querySelector('.slick-prev') : null;
        var nextBtn = parent ? parent.querySelector('.slick-next') : null;

        if (carousel.children.length > 1) {
            var slider = tns({
                container: carousel,
                items: 1,
                slideBy: 1,
                nav: false,
                controls: false, // we'll wire custom prev/next if present
                speed: 1500,
                loop: false
            });

            // If custom prev/next buttons exist, wire them to the slider API
            if (prevBtn) {
                prevBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    slider.goTo('prev');
                });
            }
            if (nextBtn) {
                nextBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    slider.goTo('next');
                });
            }
        }
    });

    // Close modal buttons
    var closeButtons = document.querySelectorAll('.notices-modal-close');
    closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.body.classList.remove('notices-modal-open');
            document.querySelectorAll('.notices-modal').forEach(function (m) {
                m.classList.remove('active');
            });
        });
    });
});


